import { render } from "./BdcomEponPortStatusTable.vue?vue&type=template&id=1bef2af6"
import script from "./BdcomEponPortStatusTable.vue?vue&type=script&lang=js"
export * from "./BdcomEponPortStatusTable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__